import { Component, TemplateRef, input, viewChild } from '@angular/core';
import { CategoryTooltipData } from '@core/models';

@Component({
  selector: 'app-categories-tooltip',
  standalone: false,
  templateUrl: './categories-tooltip.component.html',
  styleUrl: './categories-tooltip.component.scss',
})
export class CategoriesTooltipComponent {
  data = input<CategoryTooltipData>({});
  tooltipTemplate = viewChild.required<TemplateRef<void>>('tooltipTemplate');
}
